export default __webpack_public_path__ + "static/media/6.6a034266.png";